import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { TabelPaging } from '../../interfaces/table';
import {
  PCTableActionInputModel,
  PCTableFieldModel,
} from '../../models/pc-table-action-input-model';
import { DatePipe } from '@angular/common';
import { ModalConfirm } from '../../models/modal-confirm';
import { debounceTime } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import {
  BuyImportRequestDrugModal,
  BuyImportRequestModal,
} from '../../models/buy-import-modal';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';

@Component({
  selector: 'app-drug-group',
  templateUrl: './drug-group.component.html',
  styleUrls: ['./drug-group.component.css'],
})
export class DrugGroupComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private logger: LoggerService,
    private renderer: Renderer2,
    private calendarService: NewCalendarService,
    private changeDetector: ChangeDetectorRef,
    public datepipe: DatePipe,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService
  ) {
    this.endPoint = 'DrugGroup';
    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == '+') {
        this.openAddModal = true;
        this.thisValue = undefined;
      }
    });

    this.requestModel = new PCSearchRequestModel();
    this.requestModelItem = new PCSearchRequestModel();
    this.getSearchEntity();
    this.getDetailEntity();
    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Create',
          className: 'btn-outline-primary',
          icon: 'bx bx-plus',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      '',
      []
    );

    this.editableItem = new BuyImportRequestDrugModal(this.calendarService.GetNow());
    this.searchRequestModel = new PCSearchRequestModel();
    this.requestModel = new PCSearchRequestModel();
    this.requestListModel = new PCSearchRequestModel();

    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });

    if (this.endPoint != null) {
      this.action.title = this.endPoint;
    }
  }

  @Input() endPoint?: string;

  public data?: PCTableInputModel;
  public dataDetails?: PCTableInputModel;
  public paging?: TabelPaging;
  public pagingDetails?: TabelPaging;
  public action: PCTableActionInputModel;
  public fields: any[] = [];
  public openAddModal: boolean = false;
  public modalDeleteConfirm: boolean = false;
  public modalDeleteDetails: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public breadCrumb: string = '';

  public requestModel: PCSearchRequestModel;
  public requestModelItem: PCSearchRequestModel;
  public endPointUrl!: string;
  public loading: boolean = false;
  public loadingItem: boolean = false;
  public thisValue: any;
  public thisValueItem: any;


  public settingModal = new PCTableOutputModel('Settings', null);

  public confirmModal: ModalConfirm = new ModalConfirm();

  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;
  @ViewChild('addSearchDrug') addSearchDrugModal!: NgbPopover;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild('SecondPCTableComponent') secondPcTable:
    | PCTableComponent
    | undefined;

  @ViewChild('searchComponent') searchComponent: any;

  public drugSearchForm: FormGroup;
  public activeSearch: boolean = false;
  public searchLoading: boolean = false;
  public modalIsOpen: boolean = false;
  public editableItem: BuyImportRequestDrugModal;
  public searchRequestModel: PCSearchRequestModel;
  public requestListModel: PCSearchRequestModel;
  public searchData: any;
  public searchFields: any[] = [];
  public childFields: any[] = [];
  public searchPaging: any;
  public openItem: boolean = false;
  public confirmItemDelete: boolean = false;

  public ngOnInit(): void {
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        if (this.activeSearch) {
          this.searchDrug(value);
        } else {
          this.activeSearch = true;
        }
      });

    if (this.endPoint == null) {
      this.logger.addError('Endpoint is required .....!!!', false);
      return;
    }

    this.action.title = this.endPoint;
    this.generateUrl();
    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {
            let firstItemOnPage = dataResult.data?.firstItemOnPage || 1;

            if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount!=0) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }
            this.data = new PCTableInputModel(
              dataResult.data?.items,
              [
                {
                  name: 'Edit',
                  className: 'btn-outline-primary',
                  icon: 'far fa-edit',
                },
                {
                  name: 'Delete',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                },

                {
                  name: 'Add',
                  className: 'btn-outline-primary',
                  icon: 'bx bx-plus',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(dataResult);
          }
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
  }

  public getData() {
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getSingleData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.data = new PCTableInputModel(
              result.data?.items,
              [
                {
                  name: 'Edit',
                  className: 'btn-outline-primary',
                  icon: 'far fa-edit',
                },
                {
                  name: 'Delete',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                },

                {
                  name: 'Add',
                  className: 'btn-outline-primary',
                  icon: 'bx bx-plus',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            const matTable = document.querySelector('.table-responsive');
            if (matTable != null) {
              matTable.scrollTop = 0;
            }

            this.paging = this.responseService.customizePaging(result);

            setTimeout(() => {
              let selectStockPage = document.getElementById('selectStockPage');
              if (selectStockPage) {
                selectStockPage.classList.remove('animate__backInDown');
              }
            }, 2 * 1000);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }

    setTimeout(() => { }, 700);

    setTimeout(() => {
      let selectStockPage = document.getElementById('StockDetail');
      if (selectStockPage) {
        selectStockPage.classList.remove('animate__backInDown');
      }
    }, 2 * 1000);
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          this.endPoint
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public generateUrl() {
    this.endPointUrl = `${this.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public submitEdit(inputElement: any) {
    try {
      this.loading = true;

      var backentJson = this.createJson(inputElement);

      if (!this.endPoint) {
        return;
      }
      const editUrl = `${this.endPoint}/${backentJson['Id']}`;
      this.apiService
        .patchItem(new ApiRequestModel(editUrl, backentJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.clearForm(inputElement);
              this.modalSuccessConfirm = true;
              this.getSingleData();
            } else {
              this.logger.addBackEndMessage(result);
            }
          },
          (error) => {
            this.apiService.AddErrorLog(error);
          },
          () => {
            this.loading = false;
            console.log(`Completed!`);
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getDetailEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          `Drug`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.childFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.childFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
  }

  public getSearchEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          `DrugSearch`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.searchFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.searchFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
  }

  public submitAdd(inputElement: any) {
    try {
      this.loading = true;

      const title = inputElement.find(
        (current) => current.fieldName == 'Title'
      ).defaultValue;

      var backendJson = {
        title: inputElement.find((current) => current.fieldName == 'Title')
          .defaultValue,
      };

      if (!this.endPoint) {
        return;
      }

      this.apiService
        .postItem(new ApiRequestModel(this.endPoint, backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.clearForm(inputElement);
              this.modalSuccessConfirm = true;
              this.getSingleData();
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
            console.log(`Completed!`);
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public clearForm(inputElement: any) {
    try {
      for (let element of inputElement) {
        element.defValue = null;
      }
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public submitDelete() {
    try {
      this.loading = true;
      let url = `${this.endPoint}/${this.thisValue.id}`;

      this.apiService.deleteItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Delete`);
          if (result.succeeded) {
            this.getSingleData();
            this.modalSuccessConfirm = true;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public createJson(inputElement) {
    var backentJson = {};
    for (let index = 0; index < inputElement.length; index++) {
      const element = inputElement[index];
      let exactMatch = new RegExp(`ArrayList`);
      if (element.fieldDatatype.match(exactMatch) != null) {
        backentJson[element.fieldName] = [];
        if (typeof element.defValue == 'string') {
          backentJson[element.fieldName].push(element.defValue);
        } else if (element.defValue instanceof Array) {
          for (let index = 0; index < element.defValue.length; index++) {
            const defelement = element.defValue[index];
            backentJson[element.fieldName].push(defelement);
          }
        }

        continue;
      }

      exactMatch = new RegExp(`Enum`);
      if (
        element.fieldDatatype.match(exactMatch) != null &&
        element.defValue == ``
      ) {
        backentJson[element.fieldName] = null;
        continue;
      }

      if (element.defValue != null && typeof element.defValue == 'string') {
        exactMatch = new RegExp(`double`);
        if (element.defValue.match(exactMatch) != null) {
          backentJson[element.fieldName] = 0;
          continue;
        }
      }

      if (element.defValue == null && element.fieldDatatype == 'boolean') {
        backentJson[element.fieldName] = false;
        continue;
      }

      if (element.fieldDatatype == 'TimeSpan') {
        backentJson[element.fieldName] = this.changeTime(element.defValue);
        continue;
      }

      backentJson[element.fieldName] = element.defValue;
    }

    return backentJson;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.generateUrl();
        this.getSingleData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Create':
        this.openAddModal = true;
        this.thisValue = undefined;
        break;
      case 'SaveAdd':
        this.openAddModal = false;
        this.submitAdd(event.data);
        break;
      case 'Edit':
        this.thisValue = event.data;
        this.openAddModal = false;
        break;
      case 'SaveEdit':
        this.openAddModal = false;
        this.submitEdit(event.data);
        break;
      case 'Close':
        this.thisValue = undefined;
        this.openAddModal = false;
        break;
      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;

      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;
      case 'Delete':
        this.modalDeleteConfirm = true;
        this.thisValue = event.data;
        break;
      case 'NotDelete':
        this.modalDeleteConfirm = false;
        this.thisValue = undefined;
        break;
      case 'ConfirmDelete':
        this.modalDeleteConfirm = false;
        this.submitDelete();
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'Add':
        this.thisValue = event.data;
        this.getDetailsData(event.data.id, true);
        break;
      case 'CloseADD':
        this.modalService.dismissAll();
        break;
      default:
        break;
    }
  }

  public parentActionItem(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loadingItem = true;
        if (this.requestModelItem.orderBy == '') {
          this.requestModelItem.direction = 'asd';
        } else if (this.requestModelItem.orderBy != event.data) {
          this.requestModelItem.direction = 'asd';
        } else if (this.requestModelItem.direction == '') {
          this.requestModelItem.direction = 'asd';
        } else if (this.requestModelItem.direction == 'asd') {
          this.requestModelItem.direction = 'desc';
        }

        this.requestModelItem.orderBy = event.data;

        this.getDetailsData(this.thisValue.id, false);
        break;
      case 'Paging':
        this.loadingItem = true;

        this.requestModelItem.pageNumber = event.data;
        this.getDetailsData(this.thisValue.id, false);
        break;
      case 'PageSize':
        this.loadingItem = true;

        this.requestModelItem.pageSize = event.data;
        this.getDetailsData(this.thisValue.id, false);
        break;

      case 'DeleteDetails':
        this.modalDeleteDetails = true;
        this.confirmItemDelete = true;
        this.thisValueItem = event.data;
        break;

      default:
        break;
    }
  }

  public getDetailsData(id: string, andOpenModal: boolean) {
    try {
      const url = `DrugGroup/GetDrugs/${id}?pageNumber=${this.requestModelItem.pageNumber}&pageSize=${this.requestModelItem.pageSize}&paging=${this.requestModelItem.paging}&orderBy=${this.requestModelItem.orderBy}&direction=${this.requestModelItem.direction}&search=${this.requestModelItem.search}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.dataDetails = new PCTableInputModel(
              result.data?.items,
              [
                {
                  name: 'DeleteDetails',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.pagingDetails = this.responseService.customizePaging(result);
            if (andOpenModal) {
              this.openModal(this.addSearchDrugModal);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loadingItem = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingItem = false;
        },
        () => {
          this.loadingItem = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingItem = false;
    }
  }

  public changeTime(value: any): string | null {
    var timeArray = value.split(':');
    var date = new Date();
    date.setHours(timeArray[0]);
    date.setMinutes(timeArray[1]);
    date.setSeconds(0);

    return this.datepipe.transform(date, 'HH:mm:ss');
  }

  public generateSearchUrl(drugName: string): string {
    return `BuyFactor/AdvanceSearch?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;
  }

  public searchDrug(drugName: string): void {
    try {
      this.searchLoading = true;

      if (!drugName) {
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      const regexBarcode: RegExp =
        /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
      if (regexBarcode.test(drugName)) {
        const groups = drugName.match(regexBarcode)?.groups;
        this.editableItem.lot = String(groups?.['lot']);

        const expireDate: string = String(groups?.['exp']);

        const regexExpDate: RegExp = /(?<year>\d{2})(?<month>\d{2})/;
        if (regexExpDate.test(expireDate)) {
          const expiregroups = expireDate.match(regexExpDate)?.groups;

          const year: number = Number(expiregroups?.['year']);
          const month: string = String(expiregroups?.['month']);

          this.editableItem.expireDate = `20${year}-${month}-29 12:00:00`;
        }
      }
      let url = this.generateSearchUrl(drugName);

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );
            this.searchPaging = this.responseService.customizePaging(result);
            // TODO: call init() inside of Search Component
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public addNewRow(item: any) {
    try {
      const url = `DrugGroup/AddDrug`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      const backend = {
        drugId: item.id,
        drugGroupId: this.thisValue.id,
      };

      this.apiService.postItem(new ApiRequestModel(url, backend)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.modalIsOpen = false;
            this.editableItem.drugName = undefined;
            this.getDetailsData(this.thisValue.id, false);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loadingItem = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingItem = false;
        },
        () => {
          this.loadingItem = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingItem = false;
    }
  }

  public deleteRow() {
    try {
      this.loadingItem = true;
      const url = `DrugGroup/DeleteDrug/${this.thisValueItem.id}/${this.thisValue.id}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.deleteItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Delete`);
          if (result.succeeded) {
            this.getDetailsData(this.thisValue.id, false);
            this.confirmItemDelete = false;
            this.modalSuccessConfirm = true;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.searchLoading = true;
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'Paging':
        this.searchLoading = true;

        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'PageSize':
        this.searchLoading = true;
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'SelectItem':
        this.addNewRow(event.data);
        break;
      case 'ADD':
        this.openItem = true;
        this.openModal(this.addSearchDrugModal);
        break;
      default:
        break;
    }
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
          },
          (reason) => { }
        );
    } catch (error) { }
  }
}
